import React, { FC } from 'react'
import SortButton from '@ucheba/ui/components/SortButton/desktop'
import { useSortButtonCore } from '@ucheba/ui/components/SortButton/bll'
import { IProgramsPageSort } from '../types'
import { useSortItems } from '../bll'

const ProgramsPageSort: FC<IProgramsPageSort> = (props) => {
  const { programType } = props
  const items = useSortItems(programType)
  const { activeIndex, onClick } = useSortButtonCore(items)

  return <SortButton list={items} activeIndex={activeIndex} onClick={onClick} />
}

export default ProgramsPageSort
